export default __webpack_public_path__ + "static/media/instagram_darkgray1.7f3db887.svg";